import type { ReactElement } from 'react';
import { getFontFamily } from '@/theme/typography';
import { dataEl, type DataElScope } from '@/utils/dataEl';
interface MindmapCompactPreviewOverflowRowProps {
    dataElScope: DataElScope;
    overflowCount: number;
}
export function MindmapCompactPreviewOverflowRow({ dataElScope, overflowCount, }: MindmapCompactPreviewOverflowRowProps): ReactElement {
    return (
      <div data-el={dataEl(dataElScope, 'MindmapCompactPreviewOverflowRow/Status')} style={{
            display: 'flex',
            alignItems: 'center',
            gap: 8,
            fontFamily: getFontFamily(),
            fontSize: 10,
            color: 'rgba(255,255,255,0.4)',
        }}>
        <span style={{ width: 16, flexShrink: 0, color: 'rgba(147,216,255,0.4)' }}>
          └─
        </span>
        <span>
          +{overflowCount} more
        </span>
      </div>
    );
}
